// Shares of a gross sales breakdown, rounded to whole percents.
export function sharePercent(count, total) {
  if (!total) return 0;
  return Math.round((count / total) * 100);
}

// Rounded shares that add up to 100: the last one takes the rounding remainder.
export function sharesSummingTo100(counts, total) {
  if (!total) return counts.map(() => 0);
  const shares = counts.map((count) => sharePercent(count, total));
  shares[shares.length - 1] = 100 - shares.slice(0, -1).reduce((sum, share) => sum + share, 0);
  return shares;
}

// One color per offer, in the order the API sends them (same offers on every row, sorted by key).
// Full class names so Tailwind can detect them.
const CATEGORY_COLORS = [
  { bar: "bg-teal-400", text: "text-teal-700" },
  { bar: "bg-purple-600", text: "text-purple-700" },
  { bar: "bg-orange-300", text: "text-orange-700" },
  { bar: "bg-pink-400", text: "text-pink-700" },
];

export function categoryColors(index) {
  return CATEGORY_COLORS[index % CATEGORY_COLORS.length];
}

// Sequential palette, light to dark as the price rises; unknown bands stay gray.
// Full class names so Tailwind can detect them.
const BAND_CLASSES = [
  "bg-purple-100",
  "bg-purple-200",
  "bg-purple-300",
  "bg-purple-400",
  "bg-purple-500",
  "bg-purple-600",
  "bg-purple-700",
  "bg-purple-800",
  "bg-purple-900",
];

export function bandClass(band, index, knownBandsCount) {
  if (band.min == null) return "bg-gray-300";
  // Spreads the bands over the palette when there are fewer bands than shades.
  const step = knownBandsCount > 1 ? (BAND_CLASSES.length - 1) / (knownBandsCount - 1) : 0;
  return BAND_CLASSES[Math.round(index * step)];
}
